package com.patronat.top.ui.atoms.inputs

enum class InputState {
    Default,
    Active,
    Filled,
    Error,
    Success,
    Disabled,
    ReadOnly
}